module.exports = __webpack_public_path__ + "img/sara.04e6dcba.png";